module.exports = __webpack_public_path__ + "static/media/background_1400px_WEBP.a85a1b7e.webp";